"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DocumentIcon", {
  enumerable: true,
  get: function get() {
    return _DocumentIcon.DocumentIcon;
  }
});
var _DocumentIcon = require("./DocumentIcon");